import axios from 'axios';

const getVendas = (params) => axios.get('/fornecedor/compras', {
  params,
});

const getVendasList = (params) => axios.get('/fornecedor/compras/list', {
  params,
});

const getVenda = (id) => axios.get(`/fornecedor/compras/${id}`);
const aprovar = (id, compra) => axios.put(`/fornecedor/compras/${id}/aprovar`, compra);
const receberAprovar = (id, compra) => axios.put(`/fornecedor/compras/${id}/receber-aprovar`, compra);
const recusar = (id, compra) => axios.put(`/fornecedor/compras/${id}/recusar`, compra);
const confirmarRecebimento = (id, compra) => axios.put(`/fornecedor/compras/${id}/receber`, compra);

const getTotalizadores = (params) => axios.get('/fornecedor/compras/totalizadores', { params });
const notificarMensagem = (id) => axios.post(`/notificacoes/compras/${id}`, {});

const generatePdf = (id) => axios.get(`/fornecedor/compras/${id}/pdf`);

const updateNotaFiscal = (id, compra) => axios.put(`/fornecedor/compras/${id}/nota-fiscal`, compra);

export default {
  getVendas,
  getVendasList,
  getVenda,
  aprovar,
  recusar,
  confirmarRecebimento,
  receberAprovar,
  getTotalizadores,
  notificarMensagem,
  generatePdf,
  updateNotaFiscal,
};
